import { render, staticRenderFns } from "./SentSuccessModal.vue?vue&type=template&id=6abb0dee&scoped=true&"
import script from "./SentSuccessModal.vue?vue&type=script&lang=js&"
export * from "./SentSuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./SentSuccessModal.vue?vue&type=style&index=0&id=6abb0dee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb0dee",
  null
  
)

export default component.exports